import { Link } from "react-router-dom";
import { PageHeader, Reveal } from "@/components/site/Reveal";
import { PriceRow } from "@/components/site/PriceList";
import { FaqSection } from "@/components/site/Faq";
import { useContent } from "@/context/ContentContext";
import { IMG } from "@/lib/images";

const BUNAD_FAQ = [
  ["Hvor kan jeg få tilpasset bunad i Bergen?", "Hos SømSignature i Birkeveien 2, 5093 Bergen. Vi tilpasser og justerer alle typer bunader – nye, arvede og herrebunader. Bunadskonsultasjonen (15 min) er gratis."],
  ["Når bør jeg levere bunaden før 17. mai?", "Helst i januar–mars. Fra april er det høysesong, og ventetiden blir lengre. Ta kontakt så tidlig som mulig, særlig før konfirmasjon og 17. mai."],
  ["Kan dere sy inn eller slippe ut en bunad?", "Ja. Vi justerer liv og sider, og slipper ut der bunaden har sømmonn. Hvor mye som kan endres, avhenger av hvor mye stoff som er lagt inn – det vurderer vi på konsultasjonen."],
  ["Kan en arvet bunad tilpasses til ny eier?", "Ja. Arvede bunader kan ofte tilpasses ny eier med omsøm av liv, skjørt og skjorte. Vi tar vare på originale detaljer og håndverket."],
  ["Justerer dere herrebunad?", "Ja, vi justerer bukse, vest og jakke på herrebunad – for eksempel livvidde, lengde og ermer."],
  ["Hva koster bunadstilpasning?", "Konsultasjonen er gratis. Prisen avhenger av bunaden og arbeidet; du får et konkret pristilbud før vi starter. Se veiledende priser på siden."],
  ["Hva skal jeg ta med til bunadskonsultasjonen?", "Ta med hele bunaden – også skjorte, sølv og eventuelt belte – og gjerne skoene du skal bruke, så vi kan se riktig skjørtelengde."],
  ["Endrer dere broderier eller sølv?", "Vi syr ikke nye broderier og lager ikke bunadssølv. Vi kan flytte knapper og maljer og sy på løse detaljer. Ved usikkerhet vurderer Liisa dette på konsultasjonen."],
];

const STEPS = ["Gratis konsultasjon (15 min) – vi ser på bunaden sammen", "Mål, prøving og konkret pristilbud", "Tilpasning med respekt for håndverket", "Henting – klar til 17. mai, konfirmasjon eller bryllup"];

const BunadPrices = () => {
  const c = useContent();
  const items = (c?.services || []).filter((s) => s.category === "Bunad");
  if (!items.length) return null;
  return (
    <Reveal className="border border-[#E5E0D8] bg-[#FDFBF7] p-8 md:p-10">
      <div data-testid="bunad-prices">
        <p className="eyebrow mb-3">Veiledende priser</p>
        <ul>{items.map((s) => <PriceRow key={s.id} s={s} />)}</ul>
        <p className="mt-5 text-xs text-[#5C5A56]">Endelig pris avtales før arbeidet starter.</p>
      </div>
    </Reveal>
  );
};

export default function Bunad() {
  return (
    <div data-testid="bunad-page">
      <PageHeader eyebrow="Bunad i Bergen" title="Bunadstilpasning med respekt for håndverket" intro="Vi tilpasser og justerer alle typer bunader – nye, arvede og herrebunader – så den sitter perfekt til 17. mai, konfirmasjon og bryllup." testid="bunad-header" />
      <section className="px-6 md:px-16 lg:px-24 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <img src={IMG.bunad} alt="Bunadstilpasning hos SømSignature i Bergen" className="w-full h-[560px] object-cover" />
        </Reveal>
        <div className="lg:col-span-6 lg:col-start-7 space-y-10">
          <Reveal>
            <h2 className="text-4xl font-medium tracking-tight">Slik foregår det</h2>
            <ol className="mt-8 space-y-5">
              {STEPS.map((s, i) => <li key={s} className="flex gap-6 items-baseline border-b border-[#E5E0D8] pb-4"><span className="font-serif-display text-3xl text-[#C4A47C]">0{i + 1}</span><span className="text-lg">{s}</span></li>)}
            </ol>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link to="/bestill?type=bunad#forespørsel" className="px-8 py-4 bg-[#1A1A1A] text-[#FDFBF7] text-sm tracking-wide hover:bg-[#8C6E48] transition-colors duration-300" data-testid="bunad-page-quote-btn">Spør om bunad</Link>
              <Link to="/bestill" className="px-8 py-4 border border-[#1A1A1A] text-sm tracking-wide hover:bg-[#1A1A1A] hover:text-[#FDFBF7] transition-colors duration-300" data-testid="bunad-page-book-btn">Bestill gratis konsultasjon</Link>
            </div>
          </Reveal>
          <BunadPrices />
        </div>
      </section>
      <FaqSection items={BUNAD_FAQ} title="Spørsmål om bunad" testid="bunad-faq" />
    </div>
  );
}
